import { R as ResizeObserver } from './ResizeObserver-c9aca664.js';
import React__default from 'react';

var useContentScrolls = function (ref) {
    var _a = React__default.useState(false), contentScrolls = _a[0], setContentScrolls = _a[1];
    var contentRef = React__default.useRef(null);
    var thisRef = ref || contentRef;
    React__default.useEffect(function () {
        if (thisRef.current) {
            var resizeObserver = new ResizeObserver(function () {
                if (thisRef.current) {
                    var scrollHeight = thisRef.current.scrollHeight;
                    var clientHeight = thisRef.current.clientHeight;
                    var scrolls = scrollHeight > clientHeight;
                    setContentScrolls(scrolls);
                }
            });
            resizeObserver.observe(thisRef.current);
        }
    }, [setContentScrolls, thisRef]);
    return { contentScrolls: contentScrolls, contentRef: thisRef };
};

export { useContentScrolls as u };
